export enum StitchStatus {
  Created = 'created',
}

export enum ContractorStatus {
  Active = 'active',
  Deactivated = 'deactivated',
  ExpiresSoon = 'expires_soon',
  Unknown = 'unknown',
}

export enum ContractorState {
  Active = 'active',
  Deactivated = 'deactivated',
  Recollection = 'recollection',
}

export enum ContractorDeactivationReason {
  Manual = 'manual',
  Auto = 'auto',
  GracePeriod = 'grace_period',
  ExpiredDocuments = 'expired_documents',
  FailedDocument = 'failed_document',
}

export enum SubcontractorHeaderTypes {
  ALL = 'all',
  OWN = 'own',
  SUBCONTRACTOR = 'subcontractor',
}

export enum ContractorType {
  Sub = 'sub',
  Master = 'master',
  IC = 'ic',
}
